module.exports = __webpack_public_path__ + "static/media/user-avatar.5e6429a2.png";